$(function (ws) {
    'use strict';

    ws.views.lookupSelectOption = Backbone.View.extend({

        /**
         * Initializes the component.
         * Account managers are searchable based on the API
         */
        initialize: function() {
            this.accountManagerDropdown = $('#accountManager');
            this.secondaryAccountManagerDropdown = $('#secondaryAM');
            this.accountManagerSearchAndSelect(this.accountManagerDropdown);
            this.accountManagerSearchAndSelect(this.secondaryAccountManagerDropdown);
            this.eventAgg.on('accountManagerSearchAndSelect', this.accountManagerSearchAndSelect, this);

        },

        /**
         * Gets the account managers brought on page load
         */
        getDefaultAccountManagers: function (field) {
            return _.map(field.children(), function (option) {
                return {
                    id: option.value,
                    text: option.text,
                    element: option
                };
            });
        },

        accountManagerSearchAndSelect: function(field) {
            field = field ? field : this.accountManagerDropdown;
            let defaultOptions = this.getDefaultAccountManagers(field);
            field.select2({
                width: '100%',

                templateResult: function (data, container) {
                    if (data.element) {
                        $(container).addClass($(data.element).attr('class'));
                    }

                    return data.text;
                },

                ajax: {
                    url: this.model.url,
                    dataType: 'json',
                    delay: 250,
                    data: params => {
                        return {
                            searchText: params.term,
                            quoteNumber: $('.quoteID').val()
                        };
                    },

                    processResults: function (data, params) {
                        if (_.isUndefined(params.term)) {
                            params.term = '';
                        }

                        if (params.term !== '' || (isQuotingSite && data.length)) {
                            return {
                                results: _.map(data, function (element) {
                                    return {
                                        id: element.uid,
                                        text: element.displayName
                                    };
                                })
                            };
                        } else {
                            return {
                                results: defaultOptions
                            };
                        }
                    },

                    cache: true
                }
            }).on('select2:open', function (e) {
            }).on('change', function (e) {
                $('.convert-order').show();
                $('.inactive-assignedam').hide();
                $('.inActiveAM').remove();
            });
        }
    });
}(westcon));
